import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { IconCrossSmall } from '../../../../foundation/icons/IconCrossSmall/index.js';
import { IconLoading } from '../../../../foundation/icons/IconLoading/index.js';
import { ChipBadgeTypes, ChipSkins } from '../types/index.js';
import { useSkinStyles, useLayoutStyles } from '../styles/index.js';
import { ChipSizeXL } from '../sizes/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';
import { Badge } from '../../../atoms/Badge/Badge/index.js';
import { BadgeTypes } from '../../../atoms/Badge/types/index.js';
import { ScreenSizes } from '../../../../foundation/responsive/types/index.js';

const Chip = forwardRef(({ text, size = ChipSizeXL, className, icon: Icon, isActive, dataTestId, badge, onClick, onDismiss, skin = ChipSkins.Default, isFullWidth, isLoading, dataPulseName, ...props }, ref) => {
    const skinStyles = useSkinStyles();
    const sizes = computeResponsiveness(size);
    const layoutStyles = useLayoutStyles({
        sizes,
        isFullWidth,
        hasClose: !!onDismiss,
        isLoading,
    });
    return (jsxs("button", { ...props, type: "button", ref: ref, "data-is-active": !isLoading && isActive, className: clsx(layoutStyles.root, skinStyles[skin], className), "data-testid": dataTestId || 'chip', onClick: onClick, children: [isLoading && (jsx(IconLoading, { className: clsx(layoutStyles.icon, layoutStyles.loadingIcon, skinStyles.loadingIcon), "data-testid": "loading-icon" })), jsxs("div", { className: layoutStyles.interactiveArea, "data-testid": "container-icon", children: [Icon && jsx(Icon, { className: layoutStyles.icon, "data-testid": "start-icon" }), jsx("div", { className: layoutStyles.textWrap, children: jsx("span", { className: layoutStyles.text, "data-pulse-name": dataPulseName, children: text }) }), !!badge && (jsx(Badge, { className: layoutStyles.badge, variant: badge === ChipBadgeTypes.Plus ? BadgeTypes.Plus : BadgeTypes.Pro, size: 'badgeSize' in size ? size.badgeSize : {
                            [ScreenSizes.XL]: size[ScreenSizes.XL]?.badgeSize,
                            [ScreenSizes.LG]: size[ScreenSizes.LG]?.badgeSize,
                            [ScreenSizes.MD]: size[ScreenSizes.MD]?.badgeSize,
                            [ScreenSizes.SM]: size[ScreenSizes.MD]?.badgeSize,
                        } }))] }), !!onDismiss && !isLoading && (jsx("div", { onClick: e => {
                    e.stopPropagation();
                    onDismiss();
                }, className: layoutStyles.dismissButton, "data-pulse-name": "chip-close-btn", "data-testid": "container-icon-cross", children: jsx(IconCrossSmall, { className: layoutStyles.dismissIcon, "data-testid": "cross-icon" }) }))] }));
});
Chip.displayName = 'Chip';

export { Chip };
